var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.87,
    height: 20.018,
    viewBox: "0 0 22.87 20.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffa514;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.584,14.293H10.3V7.26h2.287Zm0,4.06H10.3V15.911h2.287ZM10.754.873.118,19.3a.8.8,0,0,0,.743,1.218H22.01a.8.8,0,0,0,.738-1.218c-3.514-6.15-7.1-12.251-10.584-18.427a.855.855,0,0,0-1.412,0Z",
    transform: "translate(0.002 -0.499)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.89e968d04b0aa4041e4344dfdd99530c.svg";
export { ForwardRef as ReactComponent };